// Jonak cover videos with BO autoplay disabled are initialized only after a click.
// Both layouts load wshop.js first. Resolve the observer at DOM ready, after scripts load.
$(function () {
    const observePlayer = window.observeDailymotionPlayer;
    if (typeof observePlayer === 'function' && !observePlayer.jonakManualVideo) {
        window.observeDailymotionPlayer = function (player, ...args) {
            if ($(player.getRootNode()).closest('.jonak-manual-video').length) {
                // Start a manually inserted video once at the visibility threshold.
                let hasStarted = false;
                return observePlayer({
                    getRootNode: () => player.getRootNode(),
                    pause: () => player.pause(),
                    play: () => {
                        if (hasStarted) return;
                        hasStarted = true;
                        return player.play();
                    },
                    destroy: () => player.destroy(),
                }, ...args);
            }
            return observePlayer(player, ...args);
        };
        window.observeDailymotionPlayer.jonakManualVideo = true;
    }


    $(document).off('click.jonakManualVideo', '.js-jonak-play-video')
        .on('click.jonakManualVideo', '.js-jonak-play-video', function () {
            const wrapper = $(this).closest('.jonak-manual-video').get(0);
            const content = wrapper.getAttribute('data-video-content');
            if (!content) {
                return;
            }
            wrapper.removeAttribute('data-video-content');
            wrapper.innerHTML = content;
            initDailymotionVideos();
        });
});
